<template>
    <span class="line-cursor">_</span>
</template>

<script>
    export default {
        __name: 'TerminalLineCursor',
    }
</script>

<style scoped>
    @font-face {
        font-family: orbitron;
        src: url('../../public/assets/fonts/Orbitron-Bold.ttf');
    }

    .line-cursor{
        font-family: orbitron;
        font-weight: bold;
        display: inline;
        white-space: nowrap;
        animation: blink 0.5s step-start infinite;
    }

    /* Keyframes for the blinking effect */
    @keyframes blink {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

</style>